import ProjectCompletedTasksMap from "~/records/record.projectCompletedTasksMap.jsx";
import * as actionTypes from "~/store/action_types";

// Backend returns completed_count when fetching tasks
const projectCompletedTasks = (state = new ProjectCompletedTasksMap(), action) => {
  switch (action.type) {
    case actionTypes.COMPLETE_TASK_SUCCESS:
      if (action.response && action.response.entities && action.response.entities.tasks) {
        const projectId = action.response.entities.tasks[action.taskId].project_id;
        state = state.set(`${projectId}`, state.get(`${projectId}`, 0) + 1);
      }
      return state;

    case actionTypes.OPEN_TASK_SUCCESS:
      if (action.response && action.response.entities && action.response.entities.tasks) {
        const projectId = action.response.entities.tasks[action.taskId].project_id;
        state = state.set(`${projectId}`, state.get(`${projectId}`, 0) - 1);
      }
      return state;

    case actionTypes.COMPLETE_TASK_LIST_SUCCESS: {
      const { projectId, closedTasksCount } = action;
      if (projectId && closedTasksCount) {
        state = state.set(`${projectId}`, state.get(`${projectId}`) + closedTasksCount);
      }
      return state;
    }
    case actionTypes.FETCH_TASKS_SUCCESS: {
      const { projectId, response } = action;
      const { completed_task_count } = response;

      if (projectId && completed_task_count) {
        state = state.set(`${projectId}`, completed_task_count);
      }

      return state;
    }
    case actionTypes.FETCH_PROJECTS_FOR_SCREEN_SUCCESS: {
      if (action.response.result.length > 0) {
        return state.merge(
          action.response.result.reduce((acc, id) => {
            return {
              ...acc,
              [id]: action.response.entities.projects[id].count_completed_tasks,
            };
          }, {})
        );
      }
      return state;
    }
    case actionTypes.MOVE_TASK_TO_PROJECT_SUCCESS: {
      const { projectId = 0, newProjectId = 0, copy = false, response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { tasks = {} } = entities;
      const { single: taskId = 0 } = result;
      if (projectId !== newProjectId && tasks[taskId].is_completed) {
        state = state.set(`${newProjectId}`, state.get(`${newProjectId}`) + 1);
        if (!copy) {
          state = state.set(`${projectId}`, state.get(`${projectId}`) - 1);
        }
      }
      return state;
    }
    case actionTypes.MOVE_TASK_TO_TRASH_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: taskId = 0 } = result;

      const { tasks = {} } = entities;
      const task = tasks[taskId] ?? {};
      const { project_id: projectId } = task;

      if (projectId && task.is_completed) {
        state = state.set(`${projectId}`, state.get(`${projectId}`) - 1);
      }

      return state;
    }
    case actionTypes.RESTORE_TASK_FROM_TRASH_SUCCESS: {
      const { response = {} } = action;
      const { entities = {}, result = {} } = response;
      const { single: taskId = 0 } = result;

      const { tasks = {} } = entities;
      const task = tasks[taskId] ?? {};
      const { project_id: projectId } = task;
      if (projectId && task.is_completed) {
        state = state.set(`${projectId}`, state.get(`${projectId}`) + 1);
      }
      return state;
    }

    case actionTypes.FETCH_PROJECT_SUCCESS: {
      const { response = {} } = action;
      const { result = {} } = response;
      const { count_completed_tasks = 0, single = 0 } = result;

      return state.set(`${single}`, count_completed_tasks);
    }
    default:
      if (action.response && action.response.result && action.response.result.completed_tasks_count) {
        const { completed_tasks_count } = action.response.result;
        state = state.set(`${completed_tasks_count.id}`, completed_tasks_count.count_completed);
      }
      return state;
  }
};

export default projectCompletedTasks;
